import { getConfiguration } from '@chr/common-web-ui-configuration';
import { render } from 'react-dom';
import { App } from './App';
import { initializeDataDog } from './common/utilities/datadog';
import { OnlineTranslationProvider } from '@chr/online-shared-ui-localizations';
import { ChrLdProvider } from '@chr/common-launchdarkly';
import './index.scss';

export const index = (async () => {
  try {
    const config = await getConfiguration<AppConfig>();
    initializeDataDog(config);

    render(
      <OnlineTranslationProvider>
        <ChrLdProvider envKey={config.launchDarklyClientId as string}
          context={{ key: 'external-tracking' }}>
          <App config={config} />
        </ChrLdProvider>
      </OnlineTranslationProvider>,
      document.getElementById('root')
    );
  } catch (e) {
    // This is an error that can be thrown when ES modules aren't natively supported.
    // There is a pollyfill in place so we just swallow this error.
    // Temporary until we find a better error handling solution
    if (e instanceof Error && e.message.indexOf('Error resolving module') > -1) {
      return;
    }
    console.log(e);
    render(
      <h1>Error loading application</h1>,
      document.getElementById('root'),
    );
  }
})();
